<template>
  <div class="container">
    <div style="margin-bottom:18px">
      <span class="itemtitle">提交日期：</span>
      <span>{{detail.create_time}}</span>
      <span class="itemtitle" style="margin-left:50px">账号：</span>
      <span>{{detail.user_phone}}</span>
    </div>
    <div class="itemtitle">基本信息</div>
    <div class="infobox">
      <div style="margin-bottom:20px">
        <span style="display:inline-block;width:300px">
          <span class="gray">诊所名称：</span>
          <span class="black">{{detail.hospital_name}}</span>
        </span>
        <span style="margin-right:50px">
          <span class="gray">药房类型：</span>
          <span v-if="detail.org_type==1" class="infotext">综合医院</span>
          <span v-if="detail.org_type==2" class="infotext">专科医院</span>
          <span v-if="detail.org_type==3" class="infotext">街道卫生服务中心</span>
          <span v-if="detail.org_type==4" class="infotext">社区卫生服务中心</span>
          <span v-if="detail.org_type==5" class="infotext">乡镇卫生院</span>
          <span v-if="detail.org_type==6" class="infotext">村卫生室</span>
          <span v-if="detail.org_type==7" class="infotext">企业医院</span>
          <span v-if="detail.org_type==8" class="infotext">门诊部</span>
          <span v-if="detail.org_type==9" class="infotext">个体诊所</span>
          <span v-if="detail.org_type==10" class="infotext">其他</span>
        </span>
        <span>
          <span class="gray">法人姓名：</span>
          <span class="black">{{detail.real_name}}</span>
        </span>
      </div>
      <div>
        <span style="display:inline-block;width:300px">
          <span class="gray">纳税人识别号：</span>
          <span class="black">{{detail.identification_number}}</span>
        </span>
        <span style="margin-right:50px">
          <span class="gray">所在区域：</span>
          <span class="black">{{detail.province_name}}{{detail.city_name}}{{detail.district_name}}</span>
        </span>
        <span>
          <span class="gray">联系人手机号：</span>
          <span class="black">{{detail.user_phone}}</span>
        </span>
      </div>
    </div>

    <div class="itemtitle">机构证照</div>
    <div class="imglist">
      <div class="imgitem">
        <div class="imgtext">医疗机构执业许可证</div>
        <div class="imgbox">
          <el-image class="img" :src="business_license" :preview-src-list="imgList"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
export default {
  data() {
    return {
      business_license: "",
      detail: {},
      imgList: []
    };
  },

  methods: {
    //获取药房详情
    getDetail() {
      let hospital_id = this.$route.query.hospital_id;
      this.axios
        .post("platform/clinic/getClinicInfo", { hospital_id })
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data.info;
            this.detail.create_time = platform.timestampToDate(
              this.detail.create_time
            );
            this.requestImg(
              this.detail.business_license_str,
              "business_license"
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    requestImg(src, imgname) {
      let value = this.getUrlParam("resources_id", src);
      this.axios
        .get("doctor/cms/getImg", {
          params: { resources_id: value }
        })
        .then(res => {
          this[imgname] = res;
          this.imgList.push(res);
        });
    },
    getUrlParam(key, url) {
      var reg = new RegExp("(^|\\?|&)" + key + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 24px 20px;
  box-sizing: border-box;
  background: #ffffff;
  min-width: 1000px;
  text-align: left;
  min-height: calc(100vh - 140px);
}

.black {
  color: #000;
}
.gray {
  color: #666;
  display: inline-block;
  text-align: right;
  width: 100px;
}
.itemtitle {
  color: #333;
  font-weight: 600;
  margin-bottom: 12px;
}
.infobox {
  height: 100%;
  border: solid 1px #cfcece;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
}
.imglist {
  padding-right: 40px;
  display: flex;
  justify-content: space-between;
  .imgitem {
    width: 200px;
    .imgbox {
      border: solid 1px #d6d6d6;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}
.status {
  display: inline-block;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding: 3px 8px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
}
</style>